/** @file One token row: name, scopes, dates, client setup toggle and the two-click revoke. */
import type { Translate } from '@pose2d/i18n/types';
import { useState } from 'react';
import type { TokenInfo } from '../../api/sessionTypes';
import { ConfirmButton } from '../../ui-kit/ConfirmButton';
import { ClientSetup } from './ClientSetup';

/** Props of TokenItem. */
export interface TokenItemProps {
  t: Translate;
  token: TokenInfo;
  origin: string;
  copy: (text: string) => Promise<void>;
  busy: boolean;
  onRevoke: (id: string) => void;
}

/** Revoked tokens show only their revoke date. */
export function TokenItem({ t, token, origin, copy, busy, onRevoke }: TokenItemProps) {
  const [open, setOpen] = useState(false);
  if (token.revokedAt !== null) {
    return <li className="token-item token-revoked"><strong>{token.name}</strong> <span>{t('tokens.revokedOn', { date: token.revokedAt.slice(0, 10) })}</span></li>;
  }
  const used = token.lastUsedAt === null ? t('tokens.never') : token.lastUsedAt.slice(0, 10);
  return (
    <li className="token-item">
      <strong>{token.name}</strong> <span className="shell-hint">{token.scopes.join(', ')}</span>
      <p className="project-meta">{t('tokens.meta', { created: token.createdAt.slice(0, 10), used })}</p>
      <button type="button" onClick={() => { setOpen(!open); }}>{t(open ? 'tokens.hideSetup' : 'tokens.setup')}</button>
      <ConfirmButton label={t('tokens.revoke')} confirmLabel={t('tokens.confirmRevoke', { name: token.name })} disabled={busy} onConfirm={() => { onRevoke(token.id); }} />
      {open ? <ClientSetup t={t} origin={origin} name={token.name} secret={null} copy={copy} /> : null}
    </li>
  );
}
